import * as React from 'react';
import { SVGProps } from 'react';

const IconCameraSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12 17a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m7.17 5 .574-1.383A1 1 0 0 1 8.668 3h6.664a1 1 0 0 1 .924.617L16.83 5H20c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h3.17zM18 13a6 6 0 1 1-12 0 6 6 0 0 1 12 0z"
    />
  </svg>
);
export default IconCameraSizeM;
